<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item v-if="stoId==0" label="店铺名称" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.storeName" placeholder="请输入店铺名称">
						</el-input>
					</el-form-item>
					<el-form-item label="模板名称" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.templateName" placeholder="请输入模板名称">
						</el-input>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" v-if="stoId!=0" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
		<!-- 	<el-table-column prop="id" label="编号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="storeName" v-if="stoId==0" label="店铺名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="templateName" label="模板名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			
			
			<el-table-column prop="status" label="状态" align="center" width="" :show-overflow-tooltip="true">
			<template slot-scope="scope">
				{{scope.row.status==1?'启用':'停用'}}
			</template>
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="设置" align="center" width="" :show-overflow-tooltip="true">
			<template slot-scope="scope">
				<el-button @click="dialogTShow(scope.row)">设置快递</el-button>
			
			</template>
			</el-table-column>
			<el-table-column prop="" label="操作" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					<el-button  size="small" v-if="!scope.row.status" type="text" @click="glstatus(scope.row.id,1)">启用</el-button>
					<el-button style="color: red;" size="small" v-else type="text" @click="glstatus(scope.row.id,2)">停用</el-button>　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" title="添加模板" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="模板名称">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.templateName"
							auto-complete="off" placeholder="请输入模板名称" />
					</el-form-item>
					<el-form-item label="状态" class="redItem">
					<el-switch  v-model="storeGoodsInfo.status" :active-value="true" :inactive-value="false"
						class="switchss">
					</el-switch>
					</el-form-item>
					<el-button type="primary" @click="submit" :loading="submitLoading">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
		<!-- 编辑修改 -->
		<el-dialog :visible.sync="dialogVisibleSwipers" title="编辑修改" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="模板名称">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.templateName"
							auto-complete="off" placeholder="请输入模板名称" />
					</el-form-item>
					<el-form-item label="状态" class="redItem">
					<el-switch  v-model="storeGoodsInfo.status" :active-value="true" :inactive-value="false"
						class="switchss">
					</el-switch>
					</el-form-item>
					<el-button type="primary" @click="submitClick" :loading="submitClickLoading">提交</el-button>
				
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				orderInfo: {},
				sliderlist:{},
				stoId:'',
				storeGoodsInfo: {},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,

				submitLoading: false,
				submitClickLoading: false,
			}
		},
		methods: {
			dialogTShow(it){
				this.$router.push({
					path:'/store/expressList',
					query:{
										     
							     id:it.id,
						}
					})
					
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findIndentity()

			},
			empty() { //清空
				this.orderInfo = {}

			},
			addDialogClose() {
				console.log('aaa')

				this.storeGoodsInfo = {}
			},
			findIndentity() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					// expressName:this.orderInfo.expressName
					...this.orderInfo
				}
				this.$api.findstoreExpressfee(data).then((res) => {
					console.log(res)
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
				this.submitLoading = true;
				let data = this.storeGoodsInfo
				// console.log(data)
				this.$api.addstoreExpressfee(data).then((res) => {
					console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findIndentity()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
					this.submitLoading = false;
				})

			},

			// 编辑
			editialogVisible(e) {
				
				this.storeGoodsInfo = e
				this.dialogVisibleSwipers = true

			},
			// 编辑修改提交
			submitClick() {
				this.submitClickLoading = true;
				let data = this.storeGoodsInfo
				this.$api.editstoreExpressfee(data).then((res) => {
				
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwipers = false
						this.findIndentity();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
					this.submitClickLoading = false;
				})

			},
			// 删除
			toDelete(e) {
				console.log(e)
				var str = "此操作将删除该模板, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.delstoreExpressfee(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findIndentity();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			glstatus(e,type){
				if(type==2){
					var str = "此操作将停用该模板, 是否继续?"
				}else{
					var str = "此操作将启用该模板, 是否继续?"
				}
				
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.statusstoreExpressfee(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findIndentity();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			pageChange(data) {
				this.page.pageNum = data
				this.findIndentity();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findIndentity()
			},
		},




		created() {
			this.findIndentity()
			this.$api.getUserInfo(this.$encrypt({})).then(res => {
				res.data = JSON.parse(this.$decrypt(res.data)).data
				if (res.state == 'success') {
					// console.log('登录人信息---', res.data )
					// supplierId(有值就是供应商)
					this.stoId = res.data.storeId; // storeId：0(平台)   
					
				}
			})
		}
	}
</script>

<style>

</style>
